export default __webpack_public_path__ + "static/media/banner_test.ff6ef424.png";